//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Sepsis3',
  data() {
    return {
      form:{
        vasopressors:'0',
        lactate:'0',
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        // vasopressors + lactate
        let result = form.vasopressors + form.lactate
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/Sepsis3.vue